import React from 'react';

import { QuestionContainer } from './Question.styled';
import { Heading } from 'components/v2/Typography/Heading';

import { BookingQuizCategory } from '../BookingQuiz.types';

type Props = {
  text: string;
  category?: BookingQuizCategory;
};

export const Question = ({ text }: Props) => (
  <QuestionContainer>
    <Heading tag="h3" styledAs="h3" noMargin>
      {text}
    </Heading>
  </QuestionContainer>
);
